import { Component } from '@angular/core';
import { ITooltipAngularComp } from 'ag-grid-angular';
import { ITooltipParams } from 'ag-grid-community';
import * as _ from 'underscore';

type ITooltipMessageFunc = (params: ITooltipExtendedParams) => string;

export interface ITooltipExtendedParams extends ITooltipParams {
  message?: string | ITooltipMessageFunc;
  tooltipShowExpression?(params: ITooltipExtendedParams): boolean;
}

@Component({
  selector: 'ag-tooltip',
  template: `
    <div class="ag-custom-tooltip" *ngIf="params.tooltipShowExpression ? params.tooltipShowExpression(params) : true">
      <p [innerHTML]="getTooltipMessage()"></p>
    </div>
  `,
  styleUrls: ['./ag-tooltip.scss']
})
export class AgTooltipComponent implements ITooltipAngularComp {
  public params!: ITooltipExtendedParams;

  public agInit(params: ITooltipExtendedParams): void {
    this.params = params;
  }

  public refresh(params: ITooltipExtendedParams): boolean {
    this.params = params;
    return true;
  }

  public getTooltipMessage(): string {
    if (_.isFunction(this.params.message)) {
      return this.params.message(this.params);
    } else {
      return this.params.message;
    }
  }
}